/* ===========================================================
   AFINA Water Report — ZIP → live diagnostic report.
   Pulls real contaminant data from api.afina.com (zip_codepdf.php),
   maps it to the report UI, and captures the lead in Klaviyo
   (klaviyo_w_reportapi.php). See fetchReport / buildReport / sendKlaviyo.
   =========================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-afina-wr]');
  if (!root) return;
  var SHOP_URL = root.getAttribute('data-shop-url') || '/products/filtered-showerhead';

  function hashZip(z) { var h = 0; for (var i = 0; i < z.length; i++) h = (h * 31 + z.charCodeAt(i)) >>> 0; return h; }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function svgArrow(deg) { return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"' + (deg ? ' style="transform:rotate(' + deg + 'deg)"' : '') + '><path d="M5 12h14M13 6l6 6-6 6"/></svg>'; }
  function svgCheck(color, sz) { return '<svg viewBox="0 0 24 24" width="' + (sz || 14) + '" height="' + (sz || 14) + '" fill="none" stroke="' + (color || '#fff') + '" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>'; }
  function gauge(value, max, sub, danger) {
    var R = 86, C = 2 * Math.PI * R, pct = Math.min(1, value / max);
    return '<div class="wrgauge"><svg viewBox="0 0 200 200" width="220" height="220">' +
      '<circle cx="100" cy="100" r="' + R + '" fill="none" stroke="var(--stone-200)" stroke-width="10"/>' +
      '<circle cx="100" cy="100" r="' + R + '" fill="none" stroke="' + (danger ? 'url(#wrgrad)' : 'var(--ink-900)') + '" stroke-width="10" stroke-linecap="round" stroke-dasharray="' + C + '" stroke-dashoffset="' + (C * (1 - pct)) + '" transform="rotate(-90 100 100)"/>' +
      '<defs><linearGradient id="wrgrad" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#E8E04A"/><stop offset="0.5" stop-color="#E8843E"/><stop offset="1" stop-color="#D6452F"/></linearGradient></defs></svg>' +
      '<div class="wrgauge__center"><div class="wrgauge__val serif">' + value + '</div>' + (sub ? '<div class="wrgauge__sub">' + sub + '</div>' : '') + '</div></div>';
  }
  function bar(c) {
    var pct = Math.max(6, Math.min(100, (Math.log(c.exceedance) / Math.LN10) / (Math.log(710) / Math.LN10) * 100));
    // Critical fill styling is inlined too (not just in afina-water-report.css) so the
    // bar always paints even if a cached/older stylesheet is served on the storefront.
    var fillStyle = 'display:block;width:' + pct + '%;height:100%;border-radius:999px;background:linear-gradient(90deg,#E8E04A,#E8843E 55%,#D6452F)';
    return '<div class="wrcbar"><div class="wrcbar__top"><span class="wrcbar__name">' + esc(c.name) + (c.tag ? '<span class="wrcbar__tag">' + c.tag + '</span>' : '') + '</span><span class="wrcbar__x">' + c.exceedance + '×</span></div>' +
      '<div class="wrcbar__sub">' + c.exceedance + '× over health guideline · ' + esc(c.cls) + '</div>' +
      '<div class="wrcbar__track" style="height:7px;background:var(--stone-200);border-radius:999px;overflow:hidden"><div class="wrcbar__fill" style="' + fillStyle + '"></div></div></div>';
  }
  function stat(label, value, sub, danger) {
    return '<div class="wrstat"><p class="wr__micro">' + label + '</p><div class="wrstat__n serif' + (danger ? ' wrstat__n--danger' : '') + '">' + value + '</div><p class="wrstat__sub">' + sub + '</p></div>';
  }

  function buildDynamic(rep) {
    var today = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    var scale = [['A', '90–100'], ['B', '75–89'], ['C', '60–74'], ['D', '40–59'], ['F', '0–39']];
    var gradeColor = (rep.grade === 'F' || rep.grade === 'D') ? 'var(--clay-600)' : 'var(--pine-700)';
    var html = '';
    html += '<section class="wrsec"><div class="wrap"><div class="wrresult__head"><div>' +
      '<div class="wrresult__id">REPORT · ' + esc(rep.id) + '</div>' +
      '<h1 class="serif wr__h1">Your Shower <mark>Water Report.</mark></h1>' +
      '<p class="wr__micro">Compiled for ' + esc(rep.email || '—') + ' · ' + esc(rep.zip) + ' · ' + today + '</p>' +
      '<p class="wrresult__live"><span class="wr__livedot"></span> ' + rep.households.toLocaleString() + ' households in <b>your area</b> ran this report in the last 30 days</p></div>' +
      '<button class="wrbtn-ghost" data-wr-print>' + svgArrow(90) + ' Download Report</button></div>' +
      '<div class="wrstats">' + stat('CONTAMINANTS', rep.count, 'exceeding health guidelines in your supply') +
      stat('PEAK EXCEEDANCE', rep.peak + '×', 'over the recommended health guideline', true) +
      stat('CANCER-LINKED', rep.cancer, 'contaminants associated with elevated cancer risk') + '</div></div></section>';

    html += '<section class="wrsec"><div class="wrap"><div class="wr__rule"><span>04 COMPOSITE SCORE</span><span>0–100 · weighted by exceedance &amp; cancer risk</span></div>' +
      '<p class="wr__eyebrow" style="margin-top:24px">The Afina Health Index™</p><div class="wrindex">' +
      '<div class="wrindex__gauge">' + gauge(rep.index, 100, '/ 100', true) +
      '<div class="wrindex__grade">' + rep.grade + '</div>' +
      '<p class="serif wrindex__label" style="color:' + gradeColor + '">“' + rep.label + '”</p><p class="wr__micro">GRADE ' + rep.grade + '</p></div>' +
      '<div class="wrindex__bars" data-wr-bars></div></div>' +
      '<p class="wr__method">Index methodology: 100 − Σ min(25, log₁₀(exceedance) × 8) × cancer_weight × 0.55^rank. Rank-weighted so a long tail of mild compounds doesn’t drown out the worst offender. Calibrated against EWG one-in-a-million cancer-risk Health Guidelines.</p></div></section>';

    html += '<section class="wrsec wrsec--alt"><div class="wrap wrexposure"><div>' +
      '<p class="wr__eyebrow">Exposure breakdown</p><h2 class="serif wr__h2">Your hot shower delivers <mark>more than</mark> your tap.</h2>' +
      '<p class="wr__lead">When chlorine byproducts vaporize in heat, your skin and lungs absorb them at <b>' + rep.dermal + '× the rate</b> of drinking the same water. The total trihalomethanes in your supply are the primary driver.</p></div>' +
      '<div class="wrexposure__viz"><div class="wrexposure__bar wrexposure__bar--tap"><span>1 glass of tap</span><b>1×</b></div>' +
      '<div class="wrexposure__bar wrexposure__bar--shower"><span>8-min hot shower</span><b class="serif">' + rep.dermal + '×</b></div></div></div></section>';

    html += '<section class="wrsec wrsec--dark"><div class="wrap wrcta"><p class="wr__eyebrow">Recommended remediation</p>' +
      '<h2 class="serif wr__h2">Reduce what&rsquo;s in your water &mdash; from your first shower.</h2>' +
      '<p class="wr__lead">Afina Shower Filters help reduce chlorine and heavy metals from your water, so your skin and hair get a cleaner rinse every day.</p>' +
      '<div class="wrcta__row"><a class="btn btn--primary btn--lg" href="' + SHOP_URL + '">Shop Afina Shower Filters</a>' +
      '<button class="wrbtn-ghost" data-wr-restart>Run another ZIP</button></div></div></section>';
    return html;
  }

  function renderBars(rep, showAll) {
    var shown = showAll ? rep.picks : rep.picks.slice(0, 4);
    var html = shown.map(bar).join('');
    if (rep.picks.length > 4) {
      html += '<button class="wrchip wrchip--wide" data-wr-showall>' + (showAll ? 'Hide' : 'Show all ' + rep.picks.length + ' contaminants') + '</button>';
    }
    html += '<div class="wrscale">' + [['A', '90–100'], ['B', '75–89'], ['C', '60–74'], ['D', '40–59'], ['F', '0–39']].map(function (g) {
      return '<div class="wrscale__seg' + (g[0] === rep.grade ? ' wrscale__seg--on' : '') + '"><div class="wrscale__bar"></div><b>' + g[0] + '</b><span>' + g[1] + '</span></div>';
    }).join('') + '</div>';
    return html;
  }

  var intake = root.querySelector('[data-wr-intake]');
  var result = root.querySelector('[data-wr-result]');
  var dyn = root.querySelector('[data-wr-dynamic]');
  var current = null, allShown = false;

  function show(rep) {
    current = rep; allShown = false;
    dyn.innerHTML = buildDynamic(rep);
    root.querySelector('[data-wr-bars]').innerHTML = renderBars(rep, false);
    intake.hidden = true; result.hidden = false;
    window.scrollTo({ top: 0, behavior: 'auto' });
  }
  function reset() {
    if (analyzeTimer) { clearTimeout(analyzeTimer); analyzeTimer = null; }
    IN = { step: 0, email: '', zip: '', done: 0 };
    renderIntake();
    intake.hidden = false; result.hidden = true;
    window.scrollTo({ top: 0 });
  }

  // ---- Guided intake wizard (ZIP → email → analyzing) ----
  var IN = { step: 0, email: '', zip: '', done: 0 };
  var analyzeTimer = null;
  var HOW_STEPS = [
    { t: 'Tell us your ZIP', d: 'We find the water utility that serves your home.' },
    { t: 'Add your email', d: 'We send the full report and a plan to fix it.' },
    { t: 'Read your results', d: 'See exactly what’s in your water — and how Afina helps.' }
  ];
  var ANALYZE_STEPS = [
    'Locating your local water utility',
    'Pulling the latest state testing records',
    'Screening for 90+ regulated contaminants',
    'Modeling your hot-shower skin exposure',
    'Scoring your Afina Health Index™',
    'Building your personalized filter plan'
  ];
  var HEADS = [
    { eye: 'Step 1 of 2 · Your location', h: 'What’s actually coming out of <mark>your</mark> showerhead?', lead: 'Start with your ZIP code. We pull the most recent testing from the water utility that serves your home — no account, no spam.' },
    { eye: 'Step 2 of 2 · Where to send it', h: 'Where should we send your <mark>report</mark>?', lead: 'You’ll get your full results plus a simple plan to filter out whatever we find. Your information is never sold.' },
    { eye: 'Analyzing', h: 'Reading your water <mark>right now</mark>…', lead: 'We’re cross-referencing your utility’s latest results against dermatologist-recommended health guidelines.' }
  ];
  function zipOk() { return /^\d{5}$/.test(IN.zip); }
  function emailOk() { return /.+@.+\..+/.test(IN.email); }

  function stepsListHTML() {
    return '<ol class="wrsteps">' + HOW_STEPS.map(function (s, i) {
      var cls = i === IN.step ? ' wrstep--on' : i < IN.step ? ' wrstep--done' : '';
      var num = i < IN.step ? svgCheck('#fff') : (i + 1);
      return '<li class="wrstep' + cls + '"><span class="wrstep__num">' + num + '</span><span class="wrstep__text"><b>' + s.t + '</b><span>' + s.d + '</span></span></li>';
    }).join('') + '</ol>';
  }
  function cardBodyHTML() {
    if (IN.step === 0) {
      return '<div class="wrcard__body">' +
        '<label class="wrcard__label" for="wr-zip">Your US ZIP code</label>' +
        '<div class="wrfield wrfield--lg"><input id="wr-zip" inputmode="numeric" maxlength="5" placeholder="e.g. 90210" value="' + esc(IN.zip) + '"></div>' +
        '<button class="btn btn--primary wrform__cta" data-wr-next' + (zipOk() ? '' : ' disabled') + '>Continue ' + svgArrow() + '</button>' +
        (IN.error
          ? '<p class="wrcard__note" style="color:var(--clay-600)">' + esc(IN.error) + '</p>'
          : '<p class="wrcard__note">Takes about 20 seconds. 500,000+ households have run this report.</p>') + '</div>';
    }
    if (IN.step === 1) {
      return '<div class="wrcard__body">' +
        '<label class="wrcard__label" for="wr-email">Your email address</label>' +
        '<div class="wrfield wrfield--lg"><input id="wr-email" type="email" placeholder="you@email.com" value="' + esc(IN.email) + '"></div>' +
        '<button class="btn btn--primary wrform__cta" data-wr-next' + (emailOk() ? '' : ' disabled') + '>Generate my free report ' + svgArrow() + '</button>' +
        '<button class="wrcard__back" data-wr-back>' + svgArrow(180) + ' Back · ZIP ' + esc(IN.zip) + '</button></div>';
    }
    return '<div class="wrcard__body wranalyze">' + ANALYZE_STEPS.map(function (s, i) {
      var state = i < IN.done ? 'done' : i === IN.done ? 'active' : 'wait';
      var icon = state === 'done' ? svgCheck('var(--pine-700)') : state === 'active' ? '<span class="wranalyze__spin"></span>' : '<span class="wranalyze__dot"></span>';
      return '<div class="wranalyze__row wranalyze__row--' + state + '"><span class="wranalyze__icon">' + icon + '</span><span class="wranalyze__label">' + s + '</span></div>';
    }).join('') + '</div>';
  }
  function intakeHTML() {
    var cur = HEADS[IN.step];
    return '<section class="wrsec"><div class="wrap">' +
      '<div class="wr__rule"><span>The Afina Shower Water Report</span><span>Free · No spam</span></div>' +
      '<div class="wrintake"><div class="wrintake__left">' +
      '<p class="wr__eyebrow">An Afina diagnostic</p>' +
      '<h1 class="serif wr__h1">' + cur.h + '</h1>' +
      '<p class="wr__lead">' + cur.lead + '</p>' + stepsListHTML() + '</div>' +
      '<div class="wrintake__right"><div class="wrcard">' +
      '<div class="wrcard__progress"><span class="wrcard__step">' + cur.eye + '</span>' +
      '<div class="wrcard__bar"><div class="wrcard__barFill" style="display:block;width:' + ((IN.step + 1) / 3 * 100) + '%"></div></div></div>' +
      cardBodyHTML() + '</div>' +
      '<p class="wr__trust">Compiled from state water-utility testing · Your info is never sold</p>' +
      '</div></div></div></section>';
  }
  /* ---- Live data: Afina water API + Klaviyo lead capture ---- */
  var API = 'https://api.afina.com/liveapi/zip_codepdf.php?zip_code=';
  var KLAVIYO = 'https://api.afina.com/liveapi/klaviyo_w_reportapi.php';

  function buildReport(zip, email, d) {
    var picks = (d.ContaminantList || [])
      .filter(function (c) { return c.ContaminantValue && c.ContaminantHGValue > 0 && c.ContaminantValue > c.ContaminantHGValue; })
      .map(function (c) {
        var eff = (c.ContaminantEffect || '').trim();
        return { name: c.ContaminantName, exceedance: Math.round(c.ContaminantValue / c.ContaminantHGValue),
          tag: /cancer/i.test(eff) ? 'CANCER' : null,
          cls: (eff && eff !== 'N/A') ? eff.toLowerCase() : 'detected above guideline', _c: c };
      })
      .sort(function (a, b) { return b.exceedance - a.exceedance; });
    if (!picks.length) return null;
    var cancer = picks.filter(function (p) { return p.tag === 'CANCER'; }).length;
    var penalty = 0;
    picks.forEach(function (c, i) { var w = c.tag === 'CANCER' ? 1.4 : 1; penalty += Math.min(25, Math.log(c.exceedance) / Math.LN10 * 8) * w * Math.pow(0.55, i); });
    var index = Math.max(8, Math.round(100 - penalty));
    var grade = index >= 90 ? 'A' : index >= 75 ? 'B' : index >= 60 ? 'C' : index >= 40 ? 'D' : 'F';
    var label = grade === 'F' ? 'Critical' : grade === 'D' ? 'Poor' : grade === 'C' ? 'Fair' : grade === 'B' ? 'Good' : 'Excellent';
    var h = hashZip(zip);
    return { zip: zip, email: email, picks: picks, peak: picks[0].exceedance, cancer: cancer,
      count: d.ContamsOverHBL || picks.length, index: index, grade: grade, label: label,
      dermal: (4 + Math.min(4, picks.length / 10)).toFixed(1), households: 800 + (h % 3000),
      id: 'AF-' + zip + '-' + (260000 + (h % 9999)) };
  }

  // Push the lead + top-6 contaminants to Klaviyo (best-effort; never blocks the result).
  function sendKlaviyo(rep) {
    fetch('https://api.zippopotam.us/us/' + rep.zip).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
      .then(function (z) {
        var city = '', state = '';
        if (z && z.places && z.places[0]) { city = z.places[0]['place name'] || ''; state = z.places[0]['state abbreviation'] || ''; }
        rep.picks.slice(0, 6).forEach(function (p, idx) {
          var n = idx + 1, c = p._c, fd = new FormData();
          fd.append('city', city); fd.append('email', rep.email); fd.append('zip-code', rep.zip); fd.append('state', state);
          fd.append('totalContaminants', String(rep.count));
          fd.append('healthRisks', c.ContaminantHealthRisks || c.ContaminantEffect || 'Unknown');
          fd.append('contaminant_detected_level_' + n, (c.ContaminantValue * 1000).toFixed(2));
          fd.append('contaminant_ewg_guideline_' + n, (c.ContaminantHGValue * 1000).toFixed(2));
          fd.append('contaminant_name_' + n, c.ContaminantName);
          fd.append('contaminant_national_avg_' + n, ((c.ContaminantNationalAvg || 0) * 1000).toFixed(2));
          fd.append('contaminant_ratio_' + n, (c.ContaminantValue / c.ContaminantHGValue).toFixed(1));
          fetch(KLAVIYO, { method: 'POST', body: fd }).catch(function () {});
        });
      });
  }

  function fetchReport(zip, email) {
    return fetch(API + encodeURIComponent(zip))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || d.status === 'False' || !Array.isArray(d.ContaminantList)) return null;
        var rep = buildReport(zip, email, d);
        if (rep) sendKlaviyo(rep);
        return rep;
      })
      .catch(function () { return null; });
  }

  function runAnalyze() {
    IN.done = 0;
    var report = null, dataReady = false, animDone = false;
    var fetchP = fetchReport(IN.zip, IN.email).then(function (r) { report = r; dataReady = true; });
    function finish() {
      fetchP.then(function () {
        if (report) show(report);
        else { IN.step = 0; IN.error = 'We couldn’t find water data for that ZIP — please check it and try again.'; renderIntake(); }
      });
    }
    var i = 0;
    var tick = function () {
      i += 1; IN.done = i; renderIntake();
      if (i < ANALYZE_STEPS.length) analyzeTimer = setTimeout(tick, 620);
      else analyzeTimer = setTimeout(finish, 800);
    };
    analyzeTimer = setTimeout(tick, 500);
  }
  function gotoStep(s) {
    IN.step = s; renderIntake();
    if (s === 2) runAnalyze();
    else { var inp = intake.querySelector('input'); if (inp) inp.focus(); }
  }
  function renderIntake() {
    intake.innerHTML = intakeHTML();
    var inp = intake.querySelector('input');
    if (inp && IN.step < 2) {
      inp.addEventListener('input', function () {
        if (IN.step === 0) { IN.zip = inp.value.replace(/\D/g, '').slice(0, 5); inp.value = IN.zip; IN.error = ''; }
        else { IN.email = inp.value; }
        var btn = intake.querySelector('[data-wr-next]');
        if (btn) btn.disabled = IN.step === 0 ? !zipOk() : !emailOk();
      });
      inp.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        if (IN.step === 0 && zipOk()) gotoStep(1);
        else if (IN.step === 1 && emailOk()) gotoStep(2);
      });
    }
    var nx = intake.querySelector('[data-wr-next]');
    if (nx) nx.addEventListener('click', function () {
      if (IN.step === 0 && zipOk()) gotoStep(1);
      else if (IN.step === 1 && emailOk()) gotoStep(2);
    });
    var bk = intake.querySelector('[data-wr-back]');
    if (bk) bk.addEventListener('click', function () { gotoStep(0); });
  }

  // result delegated events
  result.addEventListener('click', function (e) {
    var sa = e.target.closest('[data-wr-showall]'); if (sa) { allShown = !allShown; root.querySelector('[data-wr-bars]').innerHTML = renderBars(current, allShown); return; }
    if (e.target.closest('[data-wr-restart]')) { reset(); return; }
    if (e.target.closest('[data-wr-print]')) { window.print(); return; }
    var fq = e.target.closest('[data-wr-faq] button'); if (fq) { var it = fq.parentElement, p = it.querySelector('.wrfaq__panel'), on = it.classList.toggle('open'); p.style.maxHeight = on ? p.scrollHeight + 'px' : '0px'; }
  });
  renderIntake();
})();
